// extracted by mini-css-extract-plugin
module.exports = {"main":"Slider_main__3iXf5","label":"Slider_label__1dv7C","container":"Slider_container__1UZFn","slider":"Slider_slider__1X5Co","rangeValue":"Slider_rangeValue__2Q3Cg"};